import { ControlState, StateSystem } from "../../../shared/systems/stateSystem";
import { SyncMessageType } from "../../../shared/messageTypes";
import { GameClient } from "../gameClient";
import { ClientRecapState } from "./clientRecapState";
import { GameState } from "../../../shared/game";
import { commonEndSimulation } from "../../../shared/common";
import { ClientEndGameState } from "./clientEndGameState";
import { SoundSystem } from "../systems/soundSystem";
import { getSystem } from "../../../shared/utils";

export class ClientLobbyState extends ControlState {
	isComplete = false;

	getName(): GameState {
		return "lobby"
	}

	constructor(private gameClient: GameClient, private levelAdvanced: boolean = false) {
		super();
	}

	onEnter(controller: StateSystem): void {
		commonEndSimulation(this.gameClient);
		// The menu is silent; music runs for the duration of a game only
		getSystem(controller.world, SoundSystem).stopMusic();
		if (this.levelAdvanced) {
			this.gameClient.trainingLevelUpdated = true;
		}
		this.gameClient.updateUI();
		this.gameClient.renderEngine.background.accelerateTrails(2.0);
	}

	onExit(controller: StateSystem): void {
		getSystem(controller.world, SoundSystem).startMusic();
		controller.pushState(new ClientRecapState(this.gameClient));
		this.gameClient.updateUI();
	}

	update(delta: number): void {
		const start = this.gameClient.messageBuffer?.dequeueMessage(SyncMessageType.GotoShop)
		if (start) {
			if (this.gameClient.queueContinueGame !== null) {
				this.gameClient.sendLoadSimulation(this.gameClient.queueContinueGame);
				this.gameClient.queueContinueGame = null;
			}
			else {
				//Start the game
				this.gameClient.latestVirusGrowth = start.virusGrowth || null;
				this.gameClient.round = start.newRoundNumber;
				this.isComplete = true;
			}

			return;
		}

	}
}
